const fields = {
  clinicaServiceorderNumber: {
    attributeInIot: "clinicaServiceorderNumber.value",
    rawValue: true,
  },
  controllerType: {
    attributeInIot: "controllerType.value",
    rawValue: true,
  },
  driveType: {
    attributeInIot: "driveType.value",
    rawValue: true,
  },
  numberOfFloors: {
    attributeInIot: "numberOfFloors.value",
    rawValue: true,
  },
  identifiedRootCause: {
    attributeInIot: "identifiedRootCause.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  rootCauseEliminated: {
    attributeInIot: "rootCauseEliminated.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  identifiedRootCauseComment: {
    attributeInIot: "identifiedRootCauseComment.value",
    rawValue: true,
  },
  rootCauseEliminatedComment: {
    attributeInIot: "rootCauseEliminatedComment.value",
    rawValue: true,
  },
  furtherActions: {
    attributeInIot: "furtherActions.value",
    rawValue: true,
  },
  furtherRecommendations: {
    attributeInIot: "furtherRecommendations.value",
    rawValue: true,
  },
  understandInstructionsComment: {
    attributeInIot: "understandInstructionsComment.value",
    rawValue: true,
  },
  haveRightToolsComment: {
    attributeInIot: "haveRightToolsComment.value",
    rawValue: true,
  },
  takenAdequateProtectionComment: {
    attributeInIot: "takenAdequateProtectionComment.value",
    rawValue: true,
  },
  doneDailyChecksComment: {
    attributeInIot: "doneDailyChecksComment.value",
    rawValue: true,
  },
  rightPPEComment: {
    attributeInIot: "rightPPEComment.value",
    rawValue: true,
  },
  workIsWellOrganizedComment: {
    attributeInIot: "workIsWellOrganizedComment.value",
    rawValue: true,
  },
  atLeastTwoRisksComment: {
    attributeInIot: "atLeastTwoRisksComment.value",
    rawValue: true,
  },
  understandInstructions: {
    attributeInIot: "understandInstructions.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  haveRightTools: {
    attributeInIot: "haveRightTools.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  takenAdequateProtection: {
    attributeInIot: "takenAdequateProtection.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  doneDailyChecks: {
    attributeInIot: "doneDailyChecks.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  rightPPE: {
    attributeInIot: "rightPPE.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  workIsWellOrganized: {
    attributeInIot: "workIsWellOrganized.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  atLeastTwoRisks: {
    attributeInIot: "atLeastTwoRisks.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  landingCallStationFacePlate: {
    attributeInIot: "landingCallStationFacePlate.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      FIXT_MISSING: "FIXT_MISSING",
    },
  },
  landingCallButtons: {
    attributeInIot: "landingCallButtons.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
    },
  },
  landingCallIndicators: {
    attributeInIot: "landingCallIndicators.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
    },
  },
  mainLandingDoorPanels: {
    attributeInIot: "mainLandingDoorPanels.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  mainLandingDoorSill: {
    attributeInIot: "mainLandingDoorSill.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  mainLandingDoor: {
    attributeInIot: "mainLandingDoor.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carDoorPanels: {
    attributeInIot: "carDoorPanels.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carDoorSill: {
    attributeInIot: "carDoorSill.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carDoorsafetyDevCurtain: {
    attributeInIot: "carDoorsafetyDevCurtain.value",
    valueMap: {
      WORKING: "WORKING",
      NOTFUNCTIONING: "NOTFUNCTIONING",
      NOTSTANDARDS: "NOTSTANDARDS",
    },
  },
  carDoorGate: {
    attributeInIot: "carDoorGate.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carCeiling: {
    attributeInIot: "carCeiling.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carWallPanels: {
    attributeInIot: "carWallPanels.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carFloor: {
    attributeInIot: "carFloor.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
    },
  },
  carMirror: {
    attributeInIot: "carMirror.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
      MISSING: "MISSING",
    },
  },
  carHandrail: {
    attributeInIot: "carHandrail.value",
    valueMap: {
      GOOD: "GOOD",
      WEAR: "WEAR",
      POOR: "POOR",
      MISSING: "MISSING",
    },
  },
  carLighting: {
    attributeInIot: "carLighting.value",
    valueMap: {
      GOODLIGHT: "GOODLIGHT",
      POORLIGHT: "POORLIGHT",
      DMGLIGHT: "DMGLIGHT",
    },
  },
  twoWayComm: {
    attributeInIot: "twoWayComm.value",
    valueMap: {
      EXISTING_WIRELESS: "EXISTING_WIRELESS",
      EXISTING_LANDLINE: "EXISTING_LANDLINE",
      EXISTING_LOCAL_INTERCOM: "EXISTING_LOCAL_INTERCOM",
      MISSING: "MISSING",
    },
  },
  carOperatingPanelFaceplate: {
    attributeInIot: "carOperatingPanelFaceplate.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      FIXT_MISSING: "FIXT_MISSING",
    },
  },
  carCallButtons: {
    attributeInIot: "carCallButtons.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
    },
  },
  carDisplays: {
    attributeInIot: "carDisplays.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
      MISSING: "MISSING",
    },
  },
  otherLandingDoorPanels: {
    attributeInIot: "otherLandingDoorPanels.value",
    valueMap: {
      GOOD: "GOOD",
      EXT_DMG: "EXT_DMG",
      POORDOOR: "POORDOOR",
      MISSING: "MISSING",
    },
  },
  otherLandingDoorSill: {
    attributeInIot: "otherLandingDoorSill.value",
    valueMap: {
      GOOD: "GOOD",
      EXT_DMG: "EXT_DMG",
      POORDOOR: "POORDOOR",
    },
  },
  otherLandingDoor: {
    attributeInIot: "otherLandingDoor.value",
    valueMap: {
      GOOD: "GOOD",
      EXT_DMG: "EXT_DMG",
      POORDOOR: "POORDOOR",
    },
  },
  otherLandingCallFaceplate: {
    attributeInIot: "otherLandingCallFaceplate.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      FIXT_MISSING: "FIXT_MISSING",
    },
  },
  otherLandingCallButtons: {
    attributeInIot: "otherLandingCallButtons.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
    },
  },
  otherLandingIndicators: {
    attributeInIot: "otherLandingIndicators.value",
    valueMap: {
      NEAR_FACTORY: "NEAR_FACTORY",
      EXT_DMG: "EXT_DMG",
      NOTWORK: "NOTWORK",
      MISSING: "MISSING",
    },
  },
  driveInstallationYear: {
    attributeInIot: "driveInstallationYear.value",
    rawValue: true,
  },
  controlSystem: {
    attributeInIot: "controlSystem.value",
    valueMap: {
      ORIGINAL: "ORIGINAL",
      MODERNIZED: "MODERNIZED",
    },
  },
  controllerInstallationYear: {
    attributeInIot: "controllerInstallationYear.value",
    rawValue: true,
  },
  startCounterReading: {
    attributeInIot: "startCounterReading.value",
    rawValue: true,
  },
  machineRoomLighting: {
    attributeInIot: "machineRoomLighting.value",
    valueMap: {
      GOOD: "GOOD",
      POOR: "POOR",
      DAMAGE: "DAMAGE",
    },
  },
  machineRoomAccess: {
    attributeInIot: "machineRoomAccess.value",
    valueMap: {
      SAFE: "SAFE",
      NOTSAFE: "NOTSAFE",
    },
  },
  electricShockHazard: {
    attributeInIot: "electricShockHazard.value",
    valueMap: {
      SAFE: "SAFE",
      NOTSAFE: "NOTSAFE",
    },
  },
  markingsAndInstructions: {
    attributeInIot: "markingsAndInstructions.value",
    valueMap: {
      AVAILABLE: "AVAILABLE",
      NOT_AVAILABLE: "NOT_AVAILABLE",
    },
  },
  machineryBrakes: {
    attributeInIot: "machineryBrakes.value",
    valueMap: {
      NO_REMARKS: "NO_REMARKS",
      REQ_ADJ: "REQ_ADJ",
      REQ_REPLACEMENT: "REQ_REPLACEMENT",
    },
  },
  tractionSheave: {
    attributeInIot: "tractionSheave.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      REQ_REPLACEMENT: "REQ_REPLACEMENT",
    },
  },
  machineryMotor: {
    attributeInIot: "machineryMotor.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      REQ_REPLACEMENT: "REQ_REPLACEMENT",
    },
  },
  machineryGearbox: {
    attributeInIot: "machineryGearbox.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      POOR_COND: "POOR_COND",
    },
  },
  machinerySealings: {
    attributeInIot: "machinerySealings.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      POOR_COND: "POOR_COND",
    },
  },
  lastRopesReplacementYear: {
    attributeInIot: "lastRopesReplacementYear.value",
    rawValue: true,
  },
  valveAssembly: {
    attributeInIot: "valveAssembly.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      POOR_COND: "POOR_COND",
    },
  },
  hydraulicCylinder: {
    attributeInIot: "hydraulicCylinder.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      POOR_COND: "POOR_COND",
    },
  },
  oilHeater: {
    attributeInIot: "oilHeater.value",
    valueMap: {
      GOOD: "GOOD",
      WORN: "WORN",
      POOR_COND: "POOR_COND",
    },
  },
  lastHydraulicOilReplacementYear: {
    attributeInIot: "lastHydraulicOilReplacementYear.value",
    rawValue: true,
  },
  carTopLighting: {
    attributeInIot: "carTopLighting.value",
    valueMap: {
      GOODLIGHT: "GOODLIGHT",
      POORLIGHT: "POORLIGHT",
      DMGLIGHT: "DMGLIGHT",
    },
  },
  pitCleanliness: {
    attributeInIot: "pitCleanliness.value",
    valueMap: {
      NO_REMARKS: "NO_REMARKS",
      MINOR_REMARKS: "MINOR_REMARKS",
      REQ_ACTION: "REQ_ACTION",
    },
  },
  pitSafety: {
    attributeInIot: "pitSafety.value",
    valueMap: {
      NO_REMARKS: "NO_REMARKS",
      UNSAFE: "UNSAFE",
    },
  },
  surveyadditionalInfo: {
    attributeInIot: "surveyAdditionalInfo.value",
    rawValue: true,
  },
  signalizationMainLandingComments: {
    attributeInIot: "signalizationMainLandingComments.value",
    rawValue: true,
  },
  doorsMainLandingComments: {
    attributeInIot: "doorsMainLandingComments.value",
    rawValue: true,
  },
  doorsCarComments: {
    attributeInIot: "doorsCarComments.value",
    rawValue: true,
  },
  carInteriorComments: {
    attributeInIot: "carInteriorComments.value",
    rawValue: true,
  },
  signalizationCarComments: {
    attributeInIot: "signalizationCarComments.value",
    rawValue: true,
  },
  doorsOtherFloorsComments: {
    attributeInIot: "doorsOtherFloorsComments.value",
    rawValue: true,
  },
  signalizationOtherFloorsComments: {
    attributeInIot: "signalizationOtherFloorsComments.value",
    rawValue: true,
  },
  controlPanelComments: {
    attributeInIot: "controlPanelComments.value",
    rawValue: true,
  },
  machineMachineRoomComments: {
    attributeInIot: "machineMachineRoomComments.value",
    rawValue: true,
  },
  machineMachineryComments: {
    attributeInIot: "machineMachineryComments.value",
    rawValue: true,
  },
  shaftCarTopComments: {
    attributeInIot: "shaftCarTopComments.value",
    rawValue: true,
  },

  isKone: {
    attributeInIot: "isKone.value",
    rawValue: true,
  },
  isAutomaticLandingDoor: {
    attributeInIot: "isAutomaticLandingDoor.value",
    rawValue: true,
  },
  isAutomaticCarDoor: {
    attributeInIot: "isAutomaticCarDoor.value",
    rawValue: true,
  },
  hasCurtainOfLight: {
    attributeInIot: "hasCurtainOfLight.value",
    rawValue: true,
  },
  hasBeenModernized: {
    attributeInIot: "hasBeenModernized.value",
    rawValue: true,
  },
  hasMachineRoom: {
    attributeInIot: "hasMachineRoom.value",
    rawValue: true,
  },
  isHydraulicElevator: {
    attributeInIot: "isHydraulicElevator.value",
    rawValue: true,
  },
  hasInverterDrive: {
    attributeInIot: "hasInverterDrive.value",
    rawValue: true,
  },
  hasGearedMachine: {
    attributeInIot: "hasGearedMachine.value",
    rawValue: true,
  },

  stoppingAccuracy: {
    attributeInIot: "stoppingAccuracy.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  stoppingAccuracyActionPerformed: {
    attributeInIot: "stoppingAccuracyActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  stoppingAccuracyAdditionalInfo: {
    attributeInIot: "stoppingAccuracyAdditionalInfo.value",
    rawValue: true,
  },
  noiseLevel: {
    attributeInIot: "noiseLevel.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  noiseLevelActionPerformed: {
    attributeInIot: "noiseLevelActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  noiseLevelAdditionalInfo: {
    attributeInIot: "noiseLevelAdditionalInfo.value",
    rawValue: true,
  },
  buttonsAndKeys: {
    attributeInIot: "buttonsAndKeys.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  buttonsAndKeysActionPerformed: {
    attributeInIot: "buttonsAndKeysActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  buttonsAndKeysAdditionalInfo: {
    attributeInIot: "buttonsAndKeysAdditionalInfo.value",
    rawValue: true,
  },
  soundSignalling: {
    attributeInIot: "soundSignalling.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  soundSignallingActionPerformed: {
    attributeInIot: "soundSignallingActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  soundSignallingAdditionalInfo: {
    attributeInIot: "soundSignallingAdditionalInfo.value",
    rawValue: true,
  },
  visualSignalling: {
    attributeInIot: "visualSignalling.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  visualSignallingActionPerformed: {
    attributeInIot: "visualSignallingActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  visualSignallingAdditionalInfo: {
    attributeInIot: "visualSignallingAdditionalInfo.value",
    rawValue: true,
  },
  voicelinkFunctionalityOrOtherCommunicationDeviceIfPresent: {
    attributeInIot:
      "voicelinkFunctionalityOrOtherCommunicationDeviceIfPresent.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  voicelinkFunctionalityOrOtherCommunicationDeviceIfPresentActionPerformed: {
    attributeInIot:
      "voicelinkFunctionalityOrOtherCommunicationDeviceIfPresentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  voicelinkFunctionalityOrOtherCommunicationDeviceIfPresentAdditionalInfo: {
    attributeInIot:
      "voicelinkFunctionalityOrOtherCommunicationDeviceIfPresentAdditionalInfo.value",
    rawValue: true,
  },
  alarmButtonsFunctionality: {
    attributeInIot: "alarmButtonsFunctionality.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  alarmButtonsFunctionalityActionPerformed: {
    attributeInIot: "alarmButtonsFunctionalityActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  alarmButtonsFunctionalityAdditionalInfo: {
    attributeInIot: "alarmButtonsFunctionalityAdditionalInfo.value",
    rawValue: true,
  },
  rideComfort: {
    attributeInIot: "rideComfort.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  rideComfortActionPerformed: {
    attributeInIot: "rideComfortActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  rideComfortAdditionalInfo: {
    attributeInIot: "rideComfortAdditionalInfo.value",
    rawValue: true,
  },
  faultCodesIfAvailableAndUnderstandable: {
    attributeInIot: "faultCodesIfAvailableAndUnderstandable.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  faultCodesIfAvailableAndUnderstandableActionPerformed: {
    attributeInIot:
      "faultCodesIfAvailableAndUnderstandableActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  faultCodesIfAvailableAndUnderstandableAdditionalInfo: {
    attributeInIot:
      "faultCodesIfAvailableAndUnderstandableAdditionalInfo.value",
    rawValue: true,
  },
  softwareVersion: {
    attributeInIot: "softwareVersion.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  softwareVersionActionPerformed: {
    attributeInIot: "softwareVersionActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  softwareVersionAdditionalInfo: {
    attributeInIot: "softwareVersionAdditionalInfo.value",
    rawValue: true,
  },
  driveSoftwareVersion: {
    attributeInIot: "driveSoftwareVersion.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  driveSoftwareVersionActionPerformed: {
    attributeInIot: "driveSoftwareVersionActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  driveSoftwareVersionAdditionalInfo: {
    attributeInIot: "driveSoftwareVersionAdditionalInfo.value",
    rawValue: true,
  },
  relayMicroprosessorLce: {
    attributeInIot: "relayMicroprosessorLce.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  relayMicroprosessorLceActionPerformed: {
    attributeInIot: "relayMicroprosessorLceActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  relayMicroprosessorLceAdditionalInfo: {
    attributeInIot: "relayMicroprosessorLceAdditionalInfo.value",
    rawValue: true,
  },
  boardsAndModules: {
    attributeInIot: "boardsAndModules.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  boardsAndModulesActionPerformed: {
    attributeInIot: "boardsAndModulesActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  boardsAndModulesAdditionalInfo: {
    attributeInIot: "boardsAndModulesAdditionalInfo.value",
    rawValue: true,
  },
  v3f: {
    attributeInIot: "v3f.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  v3fActionPerformed: {
    attributeInIot: "v3fActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  v3fAdditionalInfo: {
    attributeInIot: "v3fAdditionalInfo.value",
    rawValue: true,
  },
  "1-speed": {
    attributeInIot: "1-speed.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  "1-speedActionPerformed": {
    attributeInIot: "1-speedActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  "1-speedAdditionalInfo": {
    attributeInIot: "1-speedAdditionalInfo.value",
    rawValue: true,
  },
  "2-speed": {
    attributeInIot: "2-speed.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  "2-speedActionPerformed": {
    attributeInIot: "2-speedActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  "2-speedAdditionalInfo": {
    attributeInIot: "2-speedAdditionalInfo.value",
    rawValue: true,
  },
  brakeAdjustment: {
    attributeInIot: "brakeAdjustment.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  brakeAdjustmentActionPerformed: {
    attributeInIot: "brakeAdjustmentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  brakeAdjustmentAdditionalInfo: {
    attributeInIot: "brakeAdjustmentAdditionalInfo.value",
    rawValue: true,
  },
  brakeLeverAdjustment: {
    attributeInIot: "brakeLeverAdjustment.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  brakeLeverAdjustmentActionPerformed: {
    attributeInIot: "brakeLeverAdjustmentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  brakeLeverAdjustmentAdditionalInfo: {
    attributeInIot: "brakeLeverAdjustmentAdditionalInfo.value",
    rawValue: true,
  },
  conditionOfPulleys: {
    attributeInIot: "conditionOfPulleys.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  conditionOfPulleysActionPerformed: {
    attributeInIot: "conditionOfPulleysActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  conditionOfPulleysAdditionalInfo: {
    attributeInIot: "conditionOfPulleysAdditionalInfo.value",
    rawValue: true,
  },
  conditionOfMachine: {
    attributeInIot: "conditionOfMachine.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  conditionOfMachineActionPerformed: {
    attributeInIot: "conditionOfMachineActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  conditionOfMachineAdditionalInfo: {
    attributeInIot: "conditionOfMachineAdditionalInfo.value",
    rawValue: true,
  },
  emergencyBrakeOpeningDevice: {
    attributeInIot: "emergencyBrakeOpeningDevice.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  emergencyBrakeOpeningDeviceActionPerformed: {
    attributeInIot: "emergencyBrakeOpeningDeviceActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  emergencyBrakeOpeningDeviceAdditionalInfo: {
    attributeInIot: "emergencyBrakeOpeningDeviceAdditionalInfo.value",
    rawValue: true,
  },
  tachometerAndResolverIfPresent: {
    attributeInIot: "tachometerAndResolverIfPresent.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  tachometerAndResolverIfPresentActionPerformed: {
    attributeInIot: "tachometerAndResolverIfPresentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  tachometerAndResolverIfPresentAdditionalInfo: {
    attributeInIot: "tachometerAndResolverIfPresentAdditionalInfo.value",
    rawValue: true,
  },
  routingAndDistancesOfMotorCables: {
    attributeInIot: "routingAndDistancesOfMotorCables.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  routingAndDistancesOfMotorCablesActionPerformed: {
    attributeInIot: "routingAndDistancesOfMotorCablesActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  routingAndDistancesOfMotorCablesAdditionalInfo: {
    attributeInIot: "routingAndDistancesOfMotorCablesAdditionalInfo.value",
    rawValue: true,
  },
  machineFixingAndIsolation: {
    attributeInIot: "machineFixingAndIsolation.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  machineFixingAndIsolationActionPerformed: {
    attributeInIot: "machineFixingAndIsolationActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  machineFixingAndIsolationAdditionalInfo: {
    attributeInIot: "machineFixingAndIsolationAdditionalInfo.value",
    rawValue: true,
  },
  guidesAndFixings: {
    attributeInIot: "guidesAndFixings.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  guidesAndFixingsActionPerformed: {
    attributeInIot: "guidesAndFixingsActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  guidesAndFixingsAdditionalInfo: {
    attributeInIot: "guidesAndFixingsAdditionalInfo.value",
    rawValue: true,
  },
  slidingShoeAdjustment: {
    attributeInIot: "slidingShoeAdjustment.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  slidingShoeAdjustmentActionPerformed: {
    attributeInIot: "slidingShoeAdjustmentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  slidingShoeAdjustmentAdditionalInfo: {
    attributeInIot: "slidingShoeAdjustmentAdditionalInfo.value",
    rawValue: true,
  },
  lubricatorsFunctioning: {
    attributeInIot: "lubricatorsFunctioning.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  lubricatorsFunctioningActionPerformed: {
    attributeInIot: "lubricatorsFunctioningActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  lubricatorsFunctioningAdditionalInfo: {
    attributeInIot: "lubricatorsFunctioningAdditionalInfo.value",
    rawValue: true,
  },
  suspensionRope: {
    attributeInIot: "suspensionRope.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  suspensionRopeActionPerformed: {
    attributeInIot: "suspensionRopeActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  suspensionRopeAdditionalInfo: {
    attributeInIot: "suspensionRopeAdditionalInfo.value",
    rawValue: true,
  },
  travellingCable: {
    attributeInIot: "travellingCable.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  travellingCableActionPerformed: {
    attributeInIot: "travellingCableActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  travellingCableAdditionalInfo: {
    attributeInIot: "travellingCableAdditionalInfo.value",
    rawValue: true,
  },
  governorRope: {
    attributeInIot: "governorRope.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  governorRopeActionPerformed: {
    attributeInIot: "governorRopeActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  governorRopeAdditionalInfo: {
    attributeInIot: "governorRopeAdditionalInfo.value",
    rawValue: true,
  },
  compensationRope: {
    attributeInIot: "compensationRope.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  compensationRopeActionPerformed: {
    attributeInIot: "compensationRopeActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  compensationRopeAdditionalInfo: {
    attributeInIot: "compensationRopeAdditionalInfo.value",
    rawValue: true,
  },
  systemBalancing: {
    attributeInIot: "systemBalancing.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  systemBalancingActionPerformed: {
    attributeInIot: "systemBalancingActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  systemBalancingAdditionalInfo: {
    attributeInIot: "systemBalancingAdditionalInfo.value",
    rawValue: true,
  },
  lwdAdjustment: {
    attributeInIot: "lwdAdjustment.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  lwdAdjustmentActionPerformed: {
    attributeInIot: "lwdAdjustmentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  lwdAdjustmentAdditionalInfo: {
    attributeInIot: "lwdAdjustmentAdditionalInfo.value",
    rawValue: true,
  },
  positionOfShaftSignalSwitches: {
    attributeInIot: "positionOfShaftSignalSwitches.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  positionOfShaftSignalSwitchesActionPerformed: {
    attributeInIot: "positionOfShaftSignalSwitchesActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  positionOfShaftSignalSwitchesAdditionalInfo: {
    attributeInIot: "positionOfShaftSignalSwitchesAdditionalInfo.value",
    rawValue: true,
  },
  noise: {
    attributeInIot: "noise.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  noiseActionPerformed: {
    attributeInIot: "noiseActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  noiseAdditionalInfo: {
    attributeInIot: "noiseAdditionalInfo.value",
    rawValue: true,
  },
  fillerBits: {
    attributeInIot: "fillerBits.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  fillerBitsActionPerformed: {
    attributeInIot: "fillerBitsActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  fillerBitsAdditionalInfo: {
    attributeInIot: "fillerBitsAdditionalInfo.value",
    rawValue: true,
  },
  guideShoes: {
    attributeInIot: "guideShoes.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  guideShoesActionPerformed: {
    attributeInIot: "guideShoesActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  guideShoesAdditionalInfo: {
    attributeInIot: "guideShoesAdditionalInfo.value",
    rawValue: true,
  },
  carDoorOperationIfPresent: {
    attributeInIot: "carDoorOperationIfPresent.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  carDoorOperationIfPresentActionPerformed: {
    attributeInIot: "carDoorOperationIfPresentActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  carDoorOperationIfPresentAdditionalInfo: {
    attributeInIot: "carDoorOperationIfPresentAdditionalInfo.value",
    rawValue: true,
  },
  "landingDoorSelf-closing": {
    attributeInIot: "landingDoorSelf-closing.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  "landingDoorSelf-closingActionPerformed": {
    attributeInIot: "landingDoorSelf-closingActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  "landingDoorSelf-closingAdditionalInfo": {
    attributeInIot: "landingDoorSelf-closingAdditionalInfo.value",
    rawValue: true,
  },
  landingDoorMechanicalLock: {
    attributeInIot: "landingDoorMechanicalLock.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  landingDoorMechanicalLockActionPerformed: {
    attributeInIot: "landingDoorMechanicalLockActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  landingDoorMechanicalLockAdditionalInfo: {
    attributeInIot: "landingDoorMechanicalLockAdditionalInfo.value",
    rawValue: true,
  },
  safetyEdgePhotocellCurtainOfLight: {
    attributeInIot: "safetyEdgePhotocellCurtainOfLight.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  safetyEdgePhotocellCurtainOfLightActionPerformed: {
    attributeInIot: "safetyEdgePhotocellCurtainOfLightActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  safetyEdgePhotocellCurtainOfLightAdditionalInfo: {
    attributeInIot: "safetyEdgePhotocellCurtainOfLightAdditionalInfo.value",
    rawValue: true,
  },
  closingForceLimiter: {
    attributeInIot: "closingForceLimiter.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  closingForceLimiterActionPerformed: {
    attributeInIot: "closingForceLimiterActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  closingForceLimiterAdditionalInfo: {
    attributeInIot: "closingForceLimiterAdditionalInfo.value",
    rawValue: true,
  },
  finishingAndInterior: {
    attributeInIot: "finishingAndInterior.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  finishingAndInteriorActionPerformed: {
    attributeInIot: "finishingAndInteriorActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  finishingAndInteriorAdditionalInfo: {
    attributeInIot: "finishingAndInteriorAdditionalInfo.value",
    rawValue: true,
  },
  lighting: {
    attributeInIot: "lighting.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  lightingActionPerformed: {
    attributeInIot: "lightingActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  lightingAdditionalInfo: {
    attributeInIot: "lightingAdditionalInfo.value",
    rawValue: true,
  },
  ebd: {
    attributeInIot: "ebd.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  ebdActionPerformed: {
    attributeInIot: "ebdActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  ebdAdditionalInfo: {
    attributeInIot: "ebdAdditionalInfo.value",
    rawValue: true,
  },
  ebra: {
    attributeInIot: "ebra.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  ebraActionPerformed: {
    attributeInIot: "ebraActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  ebraAdditionalInfo: {
    attributeInIot: "ebraAdditionalInfo.value",
    rawValue: true,
  },
  additionalOtherDevices: {
    attributeInIot: "additionalOtherDevices.value",
    rawValue: true,
  },
  testDrive: {
    attributeInIot: "testDrive.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  testDriveActionPerformed: {
    attributeInIot: "testDriveActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  testDriveAdditionalInfo: {
    attributeInIot: "testDriveAdditionalInfo.value",
    rawValue: true,
  },
  revellingDriveFunction: {
    attributeInIot: "revellingDriveFunction.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  revellingDriveFunctionActionPerformed: {
    attributeInIot: "revellingDriveFunctionActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  revellingDriveFunctionAdditionalInfo: {
    attributeInIot: "revellingDriveFunctionAdditionalInfo.value",
    rawValue: true,
  },
  oilLeakage: {
    attributeInIot: "oilLeakage.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  oilLeakageActionPerformed: {
    attributeInIot: "oilLeakageActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  oilLeakageAdditionalInfo: {
    attributeInIot: "oilLeakageAdditionalInfo.value",
    rawValue: true,
  },
  oilLevelInTheReservoir: {
    attributeInIot: "oilLevelInTheReservoir.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  oilLevelInTheReservoirActionPerformed: {
    attributeInIot: "oilLevelInTheReservoirActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  oilLevelInTheReservoirAdditionalInfo: {
    attributeInIot: "oilLevelInTheReservoirAdditionalInfo.value",
    rawValue: true,
  },
  oilCondition: {
    attributeInIot: "oilCondition.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  oilConditionActionPerformed: {
    attributeInIot: "oilConditionActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  oilConditionAdditionalInfo: {
    attributeInIot: "oilConditionAdditionalInfo.value",
    rawValue: true,
  },
  oilCoolingDevice: {
    attributeInIot: "oilCoolingDevice.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  oilCoolingDeviceActionPerformed: {
    attributeInIot: "oilCoolingDeviceActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  oilCoolingDeviceAdditionalInfo: {
    attributeInIot: "oilCoolingDeviceAdditionalInfo.value",
    rawValue: true,
  },
  conditionOfTheThermostat: {
    attributeInIot: "conditionOfTheThermostat.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  conditionOfTheThermostatActionPerformed: {
    attributeInIot: "conditionOfTheThermostatActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  conditionOfTheThermostatAdditionalInfo: {
    attributeInIot: "conditionOfTheThermostatAdditionalInfo.value",
    rawValue: true,
  },
  functionOfTheSafetyValve: {
    attributeInIot: "functionOfTheSafetyValve.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  functionOfTheSafetyValveActionPerformed: {
    attributeInIot: "functionOfTheSafetyValveActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  functionOfTheSafetyValveAdditionalInfo: {
    attributeInIot: "functionOfTheSafetyValveAdditionalInfo.value",
    rawValue: true,
  },
  functionOfTheSynchronismInTheTelescopicPiston: {
    attributeInIot: "functionOfTheSynchronismInTheTelescopicPiston.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  functionOfTheSynchronismInTheTelescopicPistonActionPerformed: {
    attributeInIot:
      "functionOfTheSynchronismInTheTelescopicPistonActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  functionOfTheSynchronismInTheTelescopicPistonAdditionalInfo: {
    attributeInIot:
      "functionOfTheSynchronismInTheTelescopicPistonAdditionalInfo.value",
    rawValue: true,
  },
  decelerationDistance: {
    attributeInIot: "decelerationDistance.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  decelerationDistanceActionPerformed: {
    attributeInIot: "decelerationDistanceActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  decelerationDistanceAdditionalInfo: {
    attributeInIot: "decelerationDistanceAdditionalInfo.value",
    rawValue: true,
  },
  bufferTimeOnTheControlPanel: {
    attributeInIot: "bufferTimeOnTheControlPanel.value",
    valueMap: {
      ACCEPTABLE: "ACCEPTABLE",
      NOT_ACCEPTABLE: "NOT_ACCEPTABLE",
    },
  },
  bufferTimeOnTheControlPanelActionPerformed: {
    attributeInIot: "bufferTimeOnTheControlPanelActionPerformed.value",
    valueMap: {
      NONE: "NONE",
      ADJUSTED: "ADJUSTED",
      REPLACED: "REPLACED",
      TO_BE_ADJUSTED: "TO_BE_ADJUSTED",
      TO_BE_REPLACED: "TO_BE_REPLACED",
    },
  },
  bufferTimeOnTheControlPanelAdditionalInfo: {
    attributeInIot: "bufferTimeOnTheControlPanelAdditionalInfo.value",
    rawValue: true,
  },
  measurement1AccUp: {
    attributeInIot: "measurement1AccUp.value",
    rawValue: true,
  },
  measurement1AccDn: {
    attributeInIot: "measurement1AccDn.value",
    rawValue: true,
  },
  measurement1DistanceBetween: {
    attributeInIot: "measurement1DistanceBetween.value",
    rawValue: true,
  },
  measurement1DistanceInside: {
    attributeInIot: "measurement1DistanceInside.value",
    rawValue: true,
  },
  measurement2AccUp: {
    attributeInIot: "measurement2AccUp.value",
    rawValue: true,
  },
  measurement2AccDn: {
    attributeInIot: "measurement2AccDn.value",
    rawValue: true,
  },
  measurement2DistanceBetween: {
    attributeInIot: "measurement2DistanceBetween.value",
    rawValue: true,
  },
  measurement2DistanceInside: {
    attributeInIot: "measurement2DistanceInside.value",
    rawValue: true,
  },
  measurement3AccUp: {
    attributeInIot: "measurement3AccUp.value",
    rawValue: true,
  },
  measurement3AccDn: {
    attributeInIot: "measurement3AccDn.value",
    rawValue: true,
  },
  measurement3DistanceBetween: {
    attributeInIot: "measurement3DistanceBetween.value",
    rawValue: true,
  },
  measurement3DistanceInside: {
    attributeInIot: "measurement3DistanceInside.value",
    rawValue: true,
  },
  measurement4AccUp: {
    attributeInIot: "measurement4AccUp.value",
    rawValue: true,
  },
  measurement4AccDn: {
    attributeInIot: "measurement4AccDn.value",
    rawValue: true,
  },
  measurement4DistanceBetween: {
    attributeInIot: "measurement4DistanceBetween.value",
    rawValue: true,
  },
  measurement4DistanceInside: {
    attributeInIot: "measurement4DistanceInside.value",
    rawValue: true,
  },
  measurement5AccUp: {
    attributeInIot: "measurement5AccUp.value",
    rawValue: true,
  },
  measurement5AccDn: {
    attributeInIot: "measurement5AccDn.value",
    rawValue: true,
  },
  measurement5DistanceBetween: {
    attributeInIot: "measurement5DistanceBetween.value",
    rawValue: true,
  },
  measurement5DistanceInside: {
    attributeInIot: "measurement5DistanceInside.value",
    rawValue: true,
  },
  measurement6AccUp: {
    attributeInIot: "measurement6AccUp.value",
    rawValue: true,
  },
  measurement6AccDn: {
    attributeInIot: "measurement6AccDn.value",
    rawValue: true,
  },
  measurement6DistanceBetween: {
    attributeInIot: "measurement6DistanceBetween.value",
    rawValue: true,
  },
  measurement6DistanceInside: {
    attributeInIot: "measurement6DistanceInside.value",
    rawValue: true,
  },
  measurement7AccUp: {
    attributeInIot: "measurement7AccUp.value",
    rawValue: true,
  },
  measurement7AccDn: {
    attributeInIot: "measurement7AccDn.value",
    rawValue: true,
  },
  measurement7DistanceBetween: {
    attributeInIot: "measurement7DistanceBetween.value",
    rawValue: true,
  },
  measurement7DistanceInside: {
    attributeInIot: "measurement7DistanceInside.value",
    rawValue: true,
  },
  measurement8AccUp: {
    attributeInIot: "measurement8AccUp.value",
    rawValue: true,
  },
  measurement8AccDn: {
    attributeInIot: "measurement8AccDn.value",
    rawValue: true,
  },
  measurement8DistanceBetween: {
    attributeInIot: "measurement8DistanceBetween.value",
    rawValue: true,
  },
  measurement8DistanceInside: {
    attributeInIot: "measurement8DistanceInside.value",
    rawValue: true,
  },
  measurement9AccUp: {
    attributeInIot: "measurement9AccUp.value",
    rawValue: true,
  },
  measurement9AccDn: {
    attributeInIot: "measurement9AccDn.value",
    rawValue: true,
  },
  measurement9DistanceBetween: {
    attributeInIot: "measurement9DistanceBetween.value",
    rawValue: true,
  },
  measurement9DistanceInside: {
    attributeInIot: "measurement9DistanceInside.value",
    rawValue: true,
  },
  measurement10AccUp: {
    attributeInIot: "measurement10AccUp.value",
    rawValue: true,
  },
  measurement10AccDn: {
    attributeInIot: "measurement10AccDn.value",
    rawValue: true,
  },
  measurement10DistanceBetween: {
    attributeInIot: "measurement10DistanceBetween.value",
    rawValue: true,
  },
  measurement10DistanceInside: {
    attributeInIot: "measurement10DistanceInside.value",
    rawValue: true,
  },
  measurement11AccUp: {
    attributeInIot: "measurement11AccUp.value",
    rawValue: true,
  },
  measurement11AccDn: {
    attributeInIot: "measurement11AccDn.value",
    rawValue: true,
  },
  measurement11DistanceBetween: {
    attributeInIot: "measurement11DistanceBetween.value",
    rawValue: true,
  },
  measurement11DistanceInside: {
    attributeInIot: "measurement11DistanceInside.value",
    rawValue: true,
  },
  measurement12AccUp: {
    attributeInIot: "measurement12AccUp.value",
    rawValue: true,
  },
  measurement12AccDn: {
    attributeInIot: "measurement12AccDn.value",
    rawValue: true,
  },
  measurement12DistanceBetween: {
    attributeInIot: "measurement12DistanceBetween.value",
    rawValue: true,
  },
  measurement12DistanceInside: {
    attributeInIot: "measurement12DistanceInside.value",
    rawValue: true,
  },
  measurement13AccUp: {
    attributeInIot: "measurement13AccUp.value",
    rawValue: true,
  },
  measurement13AccDn: {
    attributeInIot: "measurement13AccDn.value",
    rawValue: true,
  },
  measurement13DistanceBetween: {
    attributeInIot: "measurement13DistanceBetween.value",
    rawValue: true,
  },
  measurement13DistanceInside: {
    attributeInIot: "measurement13DistanceInside.value",
    rawValue: true,
  },
  measurement14AccUp: {
    attributeInIot: "measurement14AccUp.value",
    rawValue: true,
  },
  measurement14AccDn: {
    attributeInIot: "measurement14AccDn.value",
    rawValue: true,
  },
  measurement14DistanceBetween: {
    attributeInIot: "measurement14DistanceBetween.value",
    rawValue: true,
  },
  measurement14DistanceInside: {
    attributeInIot: "measurement14DistanceInside.value",
    rawValue: true,
  },
  measurement15AccUp: {
    attributeInIot: "measurement15AccUp.value",
    rawValue: true,
  },
  measurement15AccDn: {
    attributeInIot: "measurement15AccDn.value",
    rawValue: true,
  },
  measurement15DistanceBetween: {
    attributeInIot: "measurement15DistanceBetween.value",
    rawValue: true,
  },
  measurement15DistanceInside: {
    attributeInIot: "measurement15DistanceInside.value",
    rawValue: true,
  },

  builderUse: {
    attributeInIot: "builderUse.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  ropesLubricated: {
    attributeInIot: "ropesLubricated.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  electricalDrawingsOnSite: {
    attributeInIot: "electricalDrawingsOnSite.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
    },
  },
  generalInformationAdditionalInfo: {
    attributeInIot: "generalInformationAdditionalInfo.value",
    rawValue: true,
  },
  smoothAndquiet: {
    attributeInIot: "smoothAndquiet.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  shoeFloatBetween: {
    attributeInIot: "shoeFloatBetween.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  floorlevelscorrect: {
    attributeInIot: "floorlevelscorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  rideQualityAdditionalInfo: {
    attributeInIot: "rideQualityAdditionalInfo.value",
    rawValue: true,
  },
  machineNoiseAcceptable: {
    attributeInIot: "machineNoiseAcceptable.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  cableFittedCorrectly: {
    attributeInIot: "cableFittedCorrectly.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  clampsFittedCorrectly: {
    attributeInIot: "clampsFittedCorrectly.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  ropeTensionsEqual: {
    attributeInIot: "ropeTensionsEqual.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  filtersClear: {
    attributeInIot: "filtersClear.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  liftWellTopAdditionalInfo: {
    attributeInIot: "liftWellTopAdditionalInfo.value",
    rawValue: true,
  },
  landingDoorsSmooth: {
    attributeInIot: "landingDoorsSmooth.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  doorReopenDevicesCorrect: {
    attributeInIot: "doorReopenDevicesCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  selfClosersOperational: {
    attributeInIot: "selfClosersOperational.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  landingDoorAlignmentsChecked: {
    attributeInIot: "landingDoorAlignmentsChecked.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  lockRollerClearanceCorrect: {
    attributeInIot: "lockRollerClearanceCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  protectiveCoatingRemoved: {
    attributeInIot: "protectiveCoatingRemoved.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  carDoorOperatorFittedCorrectly: {
    attributeInIot: "carDoorOperatorFittedCorrectly.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  liftWellCarAdditionalInfo: {
    attributeInIot: "liftWellCarAdditionalInfo.value",
    rawValue: true,
  },
  osgTensionWeight: {
    attributeInIot: "osgTensionWeight.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  counterweightScreenClear: {
    attributeInIot: "counterweightScreenClear.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  pitClean: {
    attributeInIot: "pitClean.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  pitLadderCorrectLength: {
    attributeInIot: "pitLadderCorrectLength.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  overTravelLimitSticker: {
    attributeInIot: "overTravelLimitSticker.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  pitAreaAdditionalInfo: {
    attributeInIot: "pitAreaAdditionalInfo.value",
    rawValue: true,
  },
  landingAndCarPushesCorrect: {
    attributeInIot: "landingAndCarPushesCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  landingDisplaysCorrect: {
    attributeInIot: "landingDisplaysCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  carDisplaysCorrect: {
    attributeInIot: "carDisplaysCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  alarmAndAutodiallerCorrect: {
    attributeInIot: "alarmAndAutodiallerCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  signalisationAdditionalInfo: {
    attributeInIot: "signalisationAdditionalInfo.value",
    rawValue: true,
  },
  switchesFitted: {
    attributeInIot: "switchesFitted.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  overTravelLimitRampsCorrect: {
    attributeInIot: "overTravelLimitRampsCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  rboParametersCorrect: {
    attributeInIot: "rboParametersCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  en81ParameterCorrect: {
    attributeInIot: "en81ParameterCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  magnetsBraced: {
    attributeInIot: "magnetsBraced.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  doorZoneSensorDistanceCorrect: {
    attributeInIot: "doorZoneSensorDistanceCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  doorZoneSensorsSecurelyFitted: {
    attributeInIot: "doorZoneSensorsSecurelyFitted.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
    },
  },
  kceShaftsignalsAdditionalInfo: {
    attributeInIot: "kceShaftsignalsAdditionalInfo.value",
    rawValue: true,
  },
  oilPotsFitted: {
    attributeInIot: "oilPotsFitted.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  cleanDownCompleted: {
    attributeInIot: "cleanDownCompleted.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  lwdReadsCorrectly: {
    attributeInIot: "lwdReadsCorrectly.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  zonesPainted: {
    attributeInIot: "zonesPainted.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  whispedFlexGuidesCorrect: {
    attributeInIot: "whispedFlexGuidesCorrect.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  carBalancingFactorMarked: {
    attributeInIot: "carBalancingFactorMarked.value",
    valueMap: {
      YES: "YES",
      NO: "NO",
      NO_CORRECTED: "NO_CORRECTED",
      NA: "NA",
    },
  },
  finishingAdditionalInfo: {
    attributeInIot: "finishingAdditionalInfo.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyFactoryOrderNo: {
    attributeInIot: "escalatorVAsiteSurveyFactoryOrderNo.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCustomerEquipmentID: {
    attributeInIot: "escalatorVAsiteSurveyCustomerEquipmentID.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyManufacturer: {
    attributeInIot: "escalatorVAsiteSurveyManufacturer.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveyPlatform: {
    attributeInIot: "escalatorVAsiteSurveyPlatform.value",
    rawValue: true
  },
  escalatorVAsiteSurveyControllerType: {
    attributeInIot: "escalatorVAsiteSurveyControllerType.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyOperationMode: {
    attributeInIot: "escalatorVAsiteSurveyOperationMode.value",
    valueMap: {
      "KCM":"KCM Continuous Mode",
      "KSD":"KSD Star-delta",
      "KSS":"KSS Soft Start",
      "KAM":"KAM Automatic Mode",
      "K2D":"K2D 2 Direction mode",
      "KSB":"KSB Stand By Mode",
      "KST":"KST Stand By Mode with stop after adjustable Time delay",
      "KMS":"KMS Maintenance speed",
      "KVS":"KVS Variable speed mode",
      "KDB":"KDB Dynamic breaking",
      "KIB":"KIB Idle braking",
      "KRD":"KRD Restart device",
      "KEM":"KEM Escalator Monitoring",
      "KBSB":"KBSB Bypass Inverter with Stand-By mode",
      "KBST":"KBST  Bypass Inverter with Stop after adjustable Time delay",
      "NOT_KNOWN":"Not known"
    },
  },
  escalatorVAsiteSurveyInstallationYear: {
    attributeInIot: "escalatorVAsiteSurveyInstallationYear.value",
    rawValue: true,
    mapAsNumber: true
  },
  escalatorVAsiteSurveyEquipmentHasBeenModernized: {
    attributeInIot: "escalatorVAsiteSurveyEquipmentHasBeenModernized.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveyEquipmentModernizationYear: {
    attributeInIot: "escalatorVAsiteSurveyEquipmentModernizationYear.value",
    rawValue: true,
    mapAsNumber: true
  },
  escalatorVAsiteSurveyNoVisibleSteps: {
    attributeInIot: "escalatorVAsiteSurveyNoVisibleSteps.value",
    rawValue: true,
    mapAsNumber: true
  },
  escalatorVAsiteSurveyIsAutowalk: {
    attributeInIot: "escalatorVAsiteSurveyIsAutowalk.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveyAccessCoverPlates: {
    attributeInIot: "escalatorVAsiteSurveyAccessCoverPlates.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyEntryEndColumnsExistence: {
    attributeInIot: "escalatorVAsiteSurveyEntryEndColumnsExistence.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveyElectricConnectionUpgrade: {
    attributeInIot: "escalatorVAsiteSurveyElectricConnectionUpgrade.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveyEscalatorInnerDeck: {
    attributeInIot: "escalatorVAsiteSurveyEscalatorInnerDeck.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyHRinletReplacement: {
    attributeInIot: "escalatorVAsiteSurveyHRinletReplacement.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCombSegmentReplacement: {
    attributeInIot: "escalatorVAsiteSurveyCombSegmentReplacement.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCombCarrierPlateAtTheEntryEndReplacement: {
    attributeInIot: "escalatorVAsiteSurveyCombCarrierPlateAtTheEntryEndReplacement.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyDeckOrSkirtReplacement: {
    attributeInIot: "escalatorVAsiteSurveyDeckOrSkirtReplacement.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySkirtBrushExistence: {
    attributeInIot: "escalatorVAsiteSurveySkirtBrushExistence.value",
    valueMap: {
      yes: true,
      no: false,
    }
  },
  escalatorVAsiteSurveySkirtBrushReplacement: {
    attributeInIot: "escalatorVAsiteSurveySkirtBrushReplacement.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyOuterDecks: {
    attributeInIot: "escalatorVAsiteSurveyOuterDecks.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySurveyAdditionalInfoEntryEnd: {
    attributeInIot: "escalatorVAsiteSurveySurveyAdditionalInfoEntryEnd.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyTrafficLightExistence: {
    attributeInIot: "escalatorVAsiteSurveyTrafficLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyTrafficLightCondition: {
    attributeInIot: "escalatorVAsiteSurveyTrafficLightCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyHandrailLightExistence: {
    attributeInIot: "escalatorVAsiteSurveyHandrailLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyHandrailLightCondition: {
    attributeInIot: "escalatorVAsiteSurveyHandrailLightCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySkirtLightExistence: {
    attributeInIot: "escalatorVAsiteSurveySkirtLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveySkirtLightCondition: {
    attributeInIot: "escalatorVAsiteSurveySkirtLightCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyStepGapLightExistence: {
    attributeInIot: "escalatorVAsiteSurveyStepGapLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyStepGapLightCondition: {
    attributeInIot: "escalatorVAsiteSurveyStepGapLightCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCombLightExistence: {
    attributeInIot: "escalatorVAsiteSurveyCombLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyCombLightExistenceCondition: {
    attributeInIot: "escalatorVAsiteSurveyCombLightExistenceCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCladdingSoffitLightExistence: {
    attributeInIot: "escalatorVAsiteSurveyCladdingSoffitLightExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyCladdingSoffitLightCondition: {
    attributeInIot: "escalatorVAsiteSurveyCladdingSoffitLightCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySurveyAdditionalInfoLighting: {
    attributeInIot: "escalatorVAsiteSurveySurveyAdditionalInfoLighting.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyBallustradePanels: {
    attributeInIot: "escalatorVAsiteSurveyBallustradePanels.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyStepCleanliness: {
    attributeInIot: "escalatorVAsiteSurveyStepCleanliness.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyStepsribs: {
    attributeInIot: "escalatorVAsiteSurveyStepsribs.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyStepDemarcation: {
    attributeInIot: "escalatorVAsiteSurveyStepDemarcation.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySafetyguardsHeadguardExistence: {
    attributeInIot: "escalatorVAsiteSurveySafetyguardsHeadguardExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveySafetyGuardsHeadGuard: {
    attributeInIot: "escalatorVAsiteSurveySafetyGuardsHeadGuard.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySafetyguardsAntiClimbBarierExistence: {
    attributeInIot: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveySafetyguardsAntiClimbBarierCondition: {
    attributeInIot: "escalatorVAsiteSurveySafetyguardsAntiClimbBarierCondition.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardExistence: {
    attributeInIot: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardCondition: {
    attributeInIot: "escalatorVAsiteSurveySafetyGuardsantiSlidingInBetweenGuardCondition.value",
    rawValue: true,
  },
  
  escalatorVAsiteSurveyExitEndColumnsExistence: {
    attributeInIot: "escalatorVAsiteSurveyExitEndColumnsExistence.value",
    valueMap: {
      yes: true,
      no: false,
      NOT_APPLICABLE:false
    }
  },
  escalatorVAsiteSurveyElectricConnectionUpgradeExitEnd: {
    attributeInIot: "escalatorVAsiteSurveyElectricConnectionUpgradeExitEnd.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyAccessCoverAtExitEnd: {
    attributeInIot: "escalatorVAsiteSurveyAccessCoverAtExitEnd.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCombsAtExitEnd: {
    attributeInIot: "escalatorVAsiteSurveyCombsAtExitEnd.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCombCarrierPlatesAtExitEnd: {
    attributeInIot: "escalatorVAsiteSurveyCombCarrierPlatesAtExitEnd.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySafetyStickersUserInstructionsStopButtonLocation: {
    attributeInIot: "escalatorVAsiteSurveySafetyStickersUserInstructionsStopButtonLocation.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyHRInletFrontPlatesBothLHAndRH: {
    attributeInIot: "escalatorVAsiteSurveyHRInletFrontPlatesBothLHAndRH.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCheckHandrailTraction: {
    attributeInIot: "escalatorVAsiteSurveyCheckHandrailTraction.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyHandrailsOutsideInside: {
    attributeInIot: "escalatorVAsiteSurveyHandrailsOutsideInside.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyHandrailGuides: {
    attributeInIot: "escalatorVAsiteSurveyHandrailGuides.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyStepstepGapStepAlignmentAtCombArea: {
    attributeInIot: "escalatorVAsiteSurveyStepstepGapStepAlignmentAtCombArea.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySurveyAdditionalInfoSafetyComponents: {
    attributeInIot: "escalatorVAsiteSurveySurveyAdditionalInfoSafetyComponents.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyPitLightsocket: {
    attributeInIot: "escalatorVAsiteSurveyPitLightsocket.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyPitCleanliness: {
    attributeInIot: "escalatorVAsiteSurveyPitCleanliness.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyTrussCleanliness: {
    attributeInIot: "escalatorVAsiteSurveyTrussCleanliness.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyAdditionalInfoLowerPitTruss: {
    attributeInIot: "escalatorVAsiteSurveyAdditionalInfoLowerPitTruss.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyUpperPitCleanliness: {
    attributeInIot: "escalatorVAsiteSurveyUpperPitCleanliness.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyLubricators: {
    attributeInIot: "escalatorVAsiteSurveyLubricators.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyBrakeLinerThickness: {
    attributeInIot: "escalatorVAsiteSurveyBrakeLinerThickness.value",
    rawValue: true,
  },
  escalatorVAsiteSurveySurveyAdditionalInforUpperPitTruss: {
    attributeInIot: "escalatorVAsiteSurveySurveyAdditionalInforUpperPitTruss.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyInverterFans: {
    attributeInIot: "escalatorVAsiteSurveyInverterFans.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCabinetFans: {
    attributeInIot: "escalatorVAsiteSurveyCabinetFans.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyCabinetFilters: {
    attributeInIot: "escalatorVAsiteSurveyCabinetFilters.value",
    rawValue: true,
  },
  escalatorVAsiteSurveyMaincontactorsRelaysBrakeAuxBrakesReplacementYear: {
    attributeInIot: "escalatorVAsiteSurveyMaincontactorsRelaysBrakeAuxBrakesReplacementYear.value",
    rawValue: true,
    mapAsNumber: true
  },
  escalatorVAsiteSurveyInverterReplacementYear: {
    attributeInIot: "escalatorVAsiteSurveyInverterReplacementYear.value",
    rawValue: true,
    mapAsNumber: true
  },
  escalatorVAsiteSurveyAdditionalInfoController: {
    attributeInIot: "escalatorVAsiteSurveyAdditionalInfoController.value",
    rawValue: true,
  },
};

function toAppropriateDataType(field, value) {

  if (field.mapAsNumber) {
    return isNaN(value) ? 0 : Number(value)
  }
  return value;
}

/* Given a 'local' value stored in a form, return the value to be saved into 'IoT' data */
function localToExternal(field, value) {

  if (value == undefined)
    return undefined;

  if (fields[field] && fields[field].valueMap && (fields[field].valueMap[value] || fields[field].valueMap[value] === false )) {
    return fields[field].valueMap[value];
  }

  return value;
}

/* Given a 'local' value stored in a form with id field and value value, save
  it into external data under the correct attribute name, creating intermediate
  objects when necessary. */
function addToExternalData(externalData, field, localData) {

  if (fields[field]) {

    if (!fields[field].attributeInIot) {
      console.log("don't know how to add field '" + field + "' to ext. data");
      return;
    }

    var components = fields[field].attributeInIot.split(".");
    var current_element = externalData;
    for (var i_component = 0; i_component < components.length - 1; i_component++) {

      if (!current_element[components[i_component]])
        current_element[components[i_component]] = {};

      current_element = current_element[components[i_component]];
    }

    var external_value = fields[field].rawValue
      ? toAppropriateDataType(fields[field], localData.value)
      : localToExternal(field, localData.value);

    if (external_value != undefined) {
      current_element[components[components.length -1]] = external_value;
    } else {
      /* If there was no value, delete the entry */
      delete externalData[components[0]];
    }
  }
}

module.exports = {
  fields, addToExternalData
};
